"use client";
import { memo, useMemo } from "react";
import { Box, StackProps, Stack, BoxProps } from "@mui/material";
import { DropzoneInputProps, DropzoneRootProps } from "react-dropzone";
import { twMerge } from "tailwind-merge";

const AppUploadFileDropzone = ({
  file,
  url,
  className,
  children,
  rootProp,
  inputProp,
}: IAppUploadFileDropzoneProps) => {
  const imageUrl = useMemo(
    () => (file ? URL.createObjectURL(file) : ""),
    [file]
  );
  return (
    <Box className={twMerge("flex  flex-col", className)} {...rootProp}>
      <input {...inputProp} />
      {file || url ? (
        <Box
          className="max-h-[300px] max-w-full object-cover"
          component="img"
          src={imageUrl || url}
        />
      ) : (
        <>{children}</>
      )}
    </Box>
  );
};

export default memo(AppUploadFileDropzone);

export type IAppUploadFileDropzoneProps = Pick<
  BoxProps,
  "className" | "children"
> & {
  title?: string;
  description?: string;
  file?: File;
  url?: string;
  rootProp: DropzoneRootProps;
  inputProp: DropzoneInputProps;
};
